<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
                <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <route-breadcrumb/>
                </nav>
            </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <div>
                <loading :active.sync="loading" 
                    color= '#007bff'
                    :width= '128'
                    :height= '128'
                    loader='dots'
                    :can-cancel="true" 
                    :is-full-page="true">
                </loading>
            </div>
            <b-row>
                <b-col cols="12">
                    <b-card>
                        <div slot="header" class="mb-0">
                            <h3>{{language_terms['DEBIT_NOTE']}}</h3>
                        </div>
                        <b-row v-if="$route.params.id == '_new'">
                            <b-col cols="12">
                                <b-row>
                                    <b-col cols="6">
                                        <label class="form-control-label">{{language_terms["VENDOR"]}}</label>
                                            <multiselect
                                                :internalSearch = "false"
                                                v-model="dn.vendor"
                                                id="ajax"
                                                label="name"
                                                track-by="id"
                                                placeholder="Type to search"
                                                open-direction="bottom"
                                                :options="vendors"
                                                :multiple="false"
                                                :searchable="true"
                                                :clear-on-select="false"
                                                :close-on-select="true"
                                                :options-limit="300"
                                                :limit="50"
                                                :max-height="600"
                                                :show-no-results="false"
                                                :hide-selected="false"
                                                @search-change="asyncFindVendor"
                                                @input="onSelectVendor"
                                            ></multiselect>
                                    </b-col>
                                    <b-col cols="2">
                                        <base-input :label="language_terms['PURCHASE_INVOICE']" >
                                            <el-select v-model="dn.pi_document_id" filterable :placeholder="language_terms['PURCHASE_INVOICE']" @change="onSelectPI($event)" >
                                                <el-option
                                                    v-for="option in pis"
                                                    :key="option.document_id"
                                                    :label="option.code"
                                                    :value ="option.document_id">
                                                </el-option>
                                            </el-select>
                                        </base-input>
                                    </b-col>
                                    <b-col cols="2">
                                        <base-input :label="language_terms['DATE']">
                                        <flat-picker
                                            slot-scope="{ focus, blur }"
                                            @on-open="focus"
                                            @on-close="blur"
                                            style="background-color: white"
                                            class="form-control datepicker"
                                            v-model="dn.date">
                                        </flat-picker>
                                        </base-input>
                                    </b-col>

                                    <!-- <b-col cols="2">
                                        <base-input :label="language_terms['MODE']">
                                            <el-select v-model="grn.type" filterable :placeholder="language_terms['MODE']">
                                                <el-option
                                                    v-for="option in types"
                                                    :key="option.code"
                                                    :label="language_terms[option.name]"
                                                    :value ="option.code">
                                                </el-option>
                                            </el-select>
                                        </base-input>
                                    </b-col> -->
                                    <b-col cols="2">
                                        <base-input :label="language_terms['RETURN_TO']">
                                            <el-select v-model="dn.warehouse_id" filterable :placeholder="language_terms['RETURN_TO']">
                                                <el-option
                                                    v-for="option in warehouses"
                                                    :key="option.id"
                                                    :label="option.name"
                                                    :value ="option.id">
                                                </el-option>
                                            </el-select>
                                        </base-input>
                                    </b-col>
                                    <!-- <b-col cols="12" v-if="grn.type == 'GRN_PO'">
                                        <base-input :label="language_terms['PURCHASE_ORDERS']" >
                                        <el-select v-model="grn.reference_id" filterable :placeholder="language_terms['PURCHASE_ORDERS']" >
                                            <el-option
                                                v-for="option in pos"
                                                :key="option.document_id"
                                                :label="option.code"
                                                :value ="option.document_id">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                    </b-col> -->
                                    <b-col cols="12">
                                        <base-input :label="language_terms['REMARKS']">
                                            <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="dn.remarks"></textarea>
                                        </base-input>
                                    </b-col>

                                    <b-col cols="12" v-if="tableItems.length > 0">
                                        <v-client-table v-model="tableItems" :columns="tableColumns" :options="tableOptions">
                                            <div slot="qty_received" slot-scope="{row, update}">
                                                <base-input type="number" @input="update" v-model="row.qty_received" min="0"></base-input>
                                            </div>
                                            <!-- <div slot="action" slot-scope="{row}">
                                                <b-button @click="clickOnPickItem(row);"  variant="success">
                                                    <b-icon icon="basket" aria-hidden="true"></b-icon>
                                                </b-button>        
                                            </div> -->
                                        </v-client-table>
                                    </b-col>

                                </b-row>
                                <b-row>
                                    <b-col>
                                        <b-button @click="createStockCard(true)" v-if="tableItems.length > 0" variant="success">
                                            Receive + Invoice                                                    
                                        </b-button>        
                                        <b-button @click="createStockCard(false)" v-if="tableItems.length > 0" variant="primary">
                                            Receive Only                                                    
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row v-else>
                            <b-col cols="6">
                                <base-input :label="language_terms['VENDOR']" :placeholder="language_terms['VENDOR']" v-model="dn.contact_name" disabled></base-input>
                            </b-col>
                            <b-col cols="6">
                                <base-input :label="language_terms['DATE']" :placeholder="language_terms['DATE']" v-model="dn.date" disabled></base-input>
                            </b-col>
                            <b-col cols="6">
                                <base-input :label="language_terms['WAREHOUSE']" :placeholder="language_terms['WAREHOUSE']" v-model="dn.location_name" disabled></base-input>
                            </b-col>
                            <b-col cols="6">
                                <base-input :label="language_terms['REFERENCE']" :placeholder="language_terms['REFERENCE']" v-model="dn.reference_code" disabled></base-input>
                            </b-col>
                            <b-col cols="12">
                                <base-input :label="language_terms['REMARKS']" >
                                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="dn.remarks" disabled></textarea>
                                </base-input>
                            </b-col>
                            <b-col cols="12">
                                <h3>{{language_terms['GRN_ITEMS']}}</h3>
                                <b-table-simple hover responsive class="mt-3">
                                    <b-thead head-variant="light">
                                        <b-th>{{language_terms['PRODUCT_CODE']}}</b-th>
                                        <b-th>{{language_terms['PRODUCT_NAME']}}</b-th>
                                        <b-th>{{language_terms['QTY']}}</b-th>
                                        <b-th>{{language_terms['LOT_NUMBER']}}</b-th>
                                        <b-th>{{language_terms['EXPIRY_DATE']}}</b-th>
                                        <b-th>{{language_terms['LOCATION']}}</b-th>
                                    </b-thead>
                                    <b-tbody>
                                        <tr v-for="(item, index) in grn.items" :key="index">
                                            <td>{{item.product_code}}</td>
                                            <td>{{item.product_name}}</td>
                                            <td>{{item.qty}}</td>
                                            <td>{{item.lot_reference}}</td>
                                            <td>{{item.expiry_date}}</td>
                                            <td>{{item.location_name}}</td>
                                        </tr>
                                    </b-tbody>
                                </b-table-simple>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="1">
                                <base-button icon type="primary" @click.native ="goBack" v-if="$route.params.id != '_new'">
                                    {{language_terms['BACK']}}
                                </base-button>
                            </b-col>
                            <b-col cols="2">
                                <printDocument :data="grn" v-if="($route.params.id != '_new')"></printDocument> 
                            </b-col>
                        </b-row>

                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    th.VueTables__sortable {
        color:rgb(255,255,255);
    }
    td.VueTables__row  {
        color:black
    }
</style>
<script>
import { mapState } from "vuex";

import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Select, Option } from "element-ui";

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import productLookup from "@/components/Autocomplete.vue";
import moment from "moment";

import printDocument from "./printGRN.vue"

export default {
    computed:{
    ...mapState({
        language_terms: state => state.languages.language_terms,
        grn_data:(state) => state.grns.data,
        warehouses:(state)=>state.locations.warehouses,
        is_stockcard_created:(state) => state.stockcards.is_stockcard_created,
        po_list:(state) => state.purchase.po_list,
        po_items:(state) => state.purchase.po_items
      }),
    },
    components:{
        FormWizard,
        TabContent,
        Loading,
        [Select.name]: Select,
        [Option.name]: Option,
        flatPicker,
        productLookup,
        printDocument
    },
    data(){
        return{
            tableItems:[],
            tableOptions:{perPage:10000, perPageValues:[],stickyHeader:false, stickyHeaderBackground:'#292F4C',hiddenColumns:['id', 'lot', 'expiry_date'],filterable:false
            ,texts:{count:"", filter: "", filterPlaceholder: "Quick Lookup",}
            ,editableColumns: ['qty_received']                        
            ,sortIcon: {is: "glyphicon-sort",base: "glyphicon",up: "glyphicon-chevron-up",down: "glyphicon-chevron-down"},
            sortingAlgorithm(data, column) {return data.sort(this.getSortFn(column));},
            },
            tableColumns:['id','PO', 'product_code', 'product_name', 'qty_open', 'qty_received', 'lot', 'expiry_date'],
            pis:[],
            tradeitem_desp_list:[],
            desp_tags:[],
            loading: false,
            vendors:[],
            locations:[],
            is_confirmed:0,
            dn:{
                date:null,
                pi_document_id: null,                
                reference_id:"",
                expiry_mths:null,
                location:{},
                location_id:"",
                location_code:"",
                location_name:null,
                available_qty:null,
                has_lot:"0",
                expiry_mths:null,
                is_trade:0,
                allocate_qty:null,
                type:"DN",
                contact_id:'',
                contact_code:"",
                contact_name:'',
                movement_date:null,
                warehouse_id:null,
                product_name:"",
                product_id:"",
                product_code:"",
                items:[],
                remarks:"",
                trade_item:{},
                vendor:{
                    id:"",
                    code:"",
                    name:""
                },
                reference: null,
            },
            // types:[
            //     {
            //         code:"GRN_PO",
            //         name:"FROM_PO"
            //     }
            //     // ,
            //     // {
            //     //     code:"GRN",
            //     //     name:"WITHOUT_PO"
            //     // }
            // ],
            apiProductLookup: apiRoutes["PRODUCT_LOOKUP"]
        }
    },
    methods:
    {
        async onSelectPI($event)
        {
            let document_id = $event
            console.log($event)
            alert(this.pis[document_id])

        },
        async update()
        {

        },
        isFoundInList(name)
        {
            let is_found = 0
            for(let i = 0; i < this.desp_tags.length; i++)
            {
                if(this.desp_tags[i].product_name == name)
                {
                    is_found = 1
                }
            }
            return is_found;
        },
        onSelectTradeItemDesp(selectedOption)
        {
            if(selectedOption)
            {
                this.grn.product_name = selectedOption.product_name
            }
        },
        addTag(newTag)
        {
            if(newTag)
            {
                let obj = {product_name: newTag, contact_id:this.grn.contact_id, date:this.grn.movement_date}
                if(this.isFoundInList(newTag) == 0)
                {
                    this.desp_tags.push(obj)
                    Array.prototype.push.apply(this.tradeitem_desp_list, this.desp_tags); 
                    this.grn.trade_item = obj
                    this.grn.product_name = newTag
                }

            }
        },
        async asyncFindTradeItemDesp (query) 
        {
            let product_id = this.grn.product_id
            let pv = { value: query, contact_id:this.grn.contact_id, date:this.grn.movement_date, product_id: product_id};
            axios.post(apiRoutes["TRADE_ITEM_DESP_LOOKUP"], pv, authHeader()).then((response) => {
            if (response.data.code == 1) 
            {
                this.tradeitem_desp_list = response.data.data
                Array.prototype.push.apply(this.tradeitem_desp_list, this.desp_tags); 
            } 
            else 
            {
                this.tradeitem_desp_list = []
            }
            })
            .catch((error) => 
            {
            if (error.response) 
            {
                Vue.notify({
                group: "notify",
                type: "error",
                text: error.response.data.msg,
                max: 5,
                duration: 5000,
                speed: 300,
                });
            } 
            else 
            {
                console.log("Problem Querying Data", error);
            }
            });
        },
        onSelectLocationForItem(index, item)
        {
            let selectedOption = item.location
            if(selectedOption)
            {
                item.location_id = selectedOption.id
                item.location_code = selectedOption.code
                item.location_name = selectedOption.name
                this.$set(this.grn.items, index , item) 
            }
        },
        deleteItem(index)
        {
            this.grn.items.splice(index, 1);
        },
        handleCollaspe(index, row)
        {
            if(row.is_collapsed)
            {
                row.is_collapsed = false
            }
            else
            {
                row.is_collapsed = true
            }

            this.$set(this.grn_items, index , row) 
        },
        clickOnAdd()
        {
            if(this.grn.allocate_qty == '' || this.grn.allocate_qty == null || this.grn.allocate_qty ==  0 || this.grn.location_id == '')
            {
                alert("Location / Qty Required")
            }
            else
            {   
                if(this.grn.product_name == '' )
                {
                    alert("Product Name Required!")
                }
                else
                {
                    if(this.grn.type == 'GRN')
                    {
                        this.addToList()
                    }
                }
            }
        },
        addToList()
        {
            this.grn.items.push(
            {
                is_collapsed:false,
                lots:[],
                warehouse_id:this.grn.warehouse_id,
                product_id:this.grn.product_id,
                product_code:this.grn.product_code,
                product_name:this.grn.product_name,
                location_id:this.grn.location_id,
                location_code:this.grn.location_code,
                location_name:this.grn.location_name,
                allocate_qty:this.grn.allocate_qty,
                lot_reference:this.grn.lot_reference,
                expiry_date:this.grn.expiry_date,
                remarks:this.grn.item_remarks
            })

            this.grn.location = {}
            this.grn.location_id = '';
            this.grn.location_code = '';
            this.grn.location_name= '';

            this.grn.product_code = '';
            this.grn.product_id = '';
            this.grn.product_name = "",
            this.grn.has_lot = 0;
            this.grn.expiry_date = null,
            this.grn.allocate_qty = '',
            this.grn.expiry_mths = ""
            this.grn.trade_item = {}
        },
        onSelectLocation(selectedOption)
        {
            if(selectedOption)
            {
                this.grn.location_id = selectedOption.id
                this.grn.location_code = selectedOption.code
                this.grn.location_name = selectedOption.name
                this.grn.available_qty = selectedOption.available_qty
            }
        },
        async onSelectVendor(selectedOption)
        {
            if(selectedOption)
            {
                if(selectedOption.id)
                {
                    if(this.dn.contact_id != selectedOption.id)
                    {
                        this.dn.items = []
                    }
                  
                    this.dn.contact_id = selectedOption.id;
                    let pv = {contact_id:selectedOption.id};
                    await axios.post(apiRoutes["PURCHASE_RETRIEVE_PIS_FOR_DN"], pv, authHeader()).then((response) => {
                            if (response.data.code == 1) 
                            {
                                this.pis = response.data.data
                                // this.tableItems = response.data.data;
                            } else {
                                this.pis = [];
                            }

                            this.isLoading = false;
                        })
                        .catch((error) => {
                            if (error.response) {
                                alert(error.response.data.msg)
                            } else {
                                console.log("Application/Network Error", error);
                            }
                    });                    
                }
            }
        },
        async asyncFindVendor(query)
        {
            let pv = { value: query };
            await axios.post(apiRoutes["VENDOR_LOOKUP"], pv, authHeader()).then((response) => {
                    if (response.data.code == 1) 
                    {
                        this.vendors = response.data.data;
                    } else {
                        this.vendors = [];
                    }

                    this.isLoading = false;
                })
                .catch((error) => {
                    if (error.response) {
                        alert(error.response.data.msg)
                    } else {
                        console.log("Application/Network Error", error);
                    }
            });
        },
        async asyncFindLocation()
        {
            let pv = {warehouse_id: this.dn.warehouse_id, product_id:this.dn.product_id, direction:'IN', date:this.grn.date};
            await axios.post(apiRoutes['LOOKUP_LOCATIONS_BY_WH'], pv, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    this.locations = response.data.data;
                } 
                else 
                {
                    this.locations = [];
                }
                this.isLoading = false;
            }).catch((error) => {
                
            if (error.response) {
                alert(error.response.data.msg)
            } else {
                console.log("Problem submitting New Post", error);
            }
            });
        },
        goBack(){
            this.$router.push("/inventory/grns")
        },

        async createStockCard(generate_invoice)
        {
            if(this.is_confirmed == 0)
            {
                // if(this.is_confirmation_required == 1 || 1)
                if (1)
                {
                    if (generate_invoice)
                        generate_invoice = 1
                    else
                        generate_invoice = 0

                    let messages = this.confirmation_messages
                    let msg = '';
                    if (Array.isArray(messages)) {
                        msg = messages.join("\n")
                    }
                    let response = await this.$confirm(msg, 'Proceed to receive?', {
                        confirmButtonText: this.language_terms['CONFIRM'],
                        cancelButtonText: this.language_terms['CANCEL'],
                        type: 'warning'
                        }).catch(() => 
                        {
                            this.$message.info(this.language_terms['ACTION_CANCEL'])
                        })
                        if (response === 'confirm') 
                        {
                            this.loading = true

                            let payload = {
                                warehouse_id:this.grn.warehouse_id, 
                                reference_id:this.grn.reference_id,
                                remarks:this.grn.remarks,
                                movement_date:this.grn.date, 
                                items:this.tableItems, 
                                direction:'IN',
                                type:this.grn.type,
                                contact_id:this.grn.contact_id,
                                generate_invoice: generate_invoice,
                                reference: this.grn.reference,
                                is_confirmed:0
                            }
                            await this.$store.dispatch("stockcards/create", payload)
                            // await this.confirmCreateStockCard()
                            this.loading = false
                            this.$router.push("/inventory/grns")
                        }
                        else
                            this.is_stockcard_created = 0
                }
            }
            else
            {
                // await this.confirmCreateStockCard()
            }

        },
        async confirmCreateStockCard()
        {
            let payload = {
                        warehouse_id:this.grn.warehouse_id, 
                        reference_id:this.grn.reference_id,
                        remarks:this.grn.remarks,
                        movement_date:this.grn.date, 
                        items:this.grn.items, 
                        direction:'IN',
                        type:this.grn.type,
                        contact_id:this.grn.contact_id,
                        is_confirmed:1
            }
            await this.$store.dispatch("stockcards/create", payload)
        },
    },
    async mounted()
    {
        this.loading = true
        let document_code = this.$route.params.id
        
        if(document_code == '_new')
        {
            if(!this.dn.date)
            {
                this.dn.date = moment().format("YYYY-MM-DD");
            }
        }
        else
        {
            await this.$store.dispatch("dns/fetch", {code:this.$route.params.id});
            this.dn = this.dn_data
        }
        await this.$store.dispatch("locations/fetchWarehouses", {});

        if(this.warehouses.length > 0)
        {
            if(!this.dn.warehouse_id)
            {
                this.dn.warehouse_id = this.warehouses[0].id
            }
        }

        this.loading = false
    }
}
</script>
